import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObserversModule } from '@angular/cdk/observers';

import { IconsModule } from '../icons/icons.module';
import { CarouselComponent } from './carousel.component';
import { ButtonModule } from '../buttons/button.module';

@NgModule({
  declarations: [CarouselComponent],
  imports: [CommonModule, IconsModule, ObserversModule, ButtonModule],
  exports: [CarouselComponent],
})
export class CarouselModule {}
